"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _api = require("./_api");
function cov_6qi5ia3v7() {
  var path = "/home/node/project/src/event.js";
  var hash = "d0edc3693e83caece1eda5bcaf81e40df08663f4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/node/project/src/event.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 12
        },
        end: {
          line: 3,
          column: 24
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d0edc3693e83caece1eda5bcaf81e40df08663f4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_6qi5ia3v7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_6qi5ia3v7();
var url = (cov_6qi5ia3v7().s[0]++, '/api/Event');
var _default = exports["default"] = (0, _api.createBaseOperations)(url);